import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { WarehouseOrganizationInfoService } from 'common/data';

class WarehouseOrganizationInfoStore extends BaseStore {
	constructor(rootStore) {
		super(new WarehouseOrganizationInfoService(rootStore.app.baasic.apiClient));
	
	}

	@action async findWarehouseOrganizationInfo(filter) {
		const response = await this.service.find(filter);
		if (filter && filter.search) {
			response.data.searchQuery = filter.search;
		}
		this.response = response.data;
	}

	@action async getWarehouseOrganizationInfo(id, options) {
		const warehouse = await this.service.get(id, options);
		this.item = warehouse.data;
	}

	@action async updateWarehouseOrganizationInfo(warehouseOrganizationInfo, sourceOfChange) {
		await this.service.update(warehouseOrganizationInfo, sourceOfChange);
	}

	@action async closeOutPalletizing(sourceOfChange, warehouseId = null) {
		const response = await this.service.closeOutPalletizing(sourceOfChange, warehouseId);
		this.item = response;
		return this.item.data;
	}

	@action async closeOutExitScan(sourceOfChange, warehouseId = null) {
		const response = await this.service.closeOutExitScan(sourceOfChange, warehouseId);
		this.item = response;
		return this.item.data;
	}

	@action async createWarehouseOrganizationInfo(warehouseOrganizationInfo) {
		const response = await this.service.create(warehouseOrganizationInfo);
		this.item = response;
		return this.item.data;
	}

	@action async adjustInventory(warehouseActivities, sourceOfChange) {
		const response = await this.service.adjustInventory(warehouseActivities, sourceOfChange);
		this.item = response;
		return this.item.data;
	}

	@action async deleteWarehouseOrganizationInfo(warehouseOrganizationInfo) {
		warehouseOrganizationInfo = { id: warehouseOrganizationInfo.id };
		await this.service.delete(warehouseOrganizationInfo);
	}
}

export default WarehouseOrganizationInfoStore;



// WEBPACK FOOTER //
// ./src/modules/warehouse/stores/WarehouseOrganizationInfoStore.js